'use client';

import { c as _c } from "react/compiler-runtime";
import './geo-banner.scss';
import { deleteCookie, setCookie } from 'cookies-next/client';
import { useTranslation } from 'react-i18next';
import { Intl } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Prominence, Sizes, Text, Variants } from '@sola/ark-core/atoms/text/text.tsx';
import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.tsx';
import { RadioGroup } from '@sola/ark-core/molecules/radio-group/radio-group.tsx';
import { type PartnerCountryCode, partnerSiteUrls } from '@sola/schema/dotcom/shared/geo.ts';
import { FeatureBase } from '../../molecules/feature-base/feature-base.tsx';
import { FlexibleSection } from '../flexible-section/flexible-section.tsx';
import { geoCookieName, useGeoBanner } from './geo-banner.logic.ts';
const radioValues = {
  yes: 'Yes',
  no: 'No'
};
const InnerGeoBanner = t0 => {
  const $ = _c(34);
  const {
    countryCode,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core", "geo"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const handleDontAskToggle = _temp;
  let t2;
  if ($[1] !== countryCode) {
    t2 = <Text variant={Variants.Label} prominence={Prominence.Potent} size={Sizes.XLarge}><Intl k="geo:redirectBanner.title" variables={{
        context: countryCode
      }} /></Text>;
    $[1] = countryCode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== countryCode || $[4] !== onClose) {
    t3 = v => {
      if (v.target.value === radioValues.no) {
        onClose();
      }
      if (v.target.value === radioValues.yes) {
        globalThis.location.href = partnerSiteUrls[countryCode];
      }
    };
    $[3] = countryCode;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("core:actions.yes");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      value: radioValues.yes,
      text: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("core:actions.no");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = {
      value: radioValues.no,
      text: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = [t5, t7];
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t8) {
    t9 = <RadioGroup name="geo-redirect" variant="buttons" onChange={t3} items={t8} />;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t9) {
    t10 = <div className="GeoBanner__radioGroup">{t2}{t9}</div>;
    $[20] = t2;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("geo:redirectBanner.dontAskAgain");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_0 => handleDontAskToggle(e_0);
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11) {
    t13 = <Checkbox label={t11} name="geoRedirectDontAskAgain" onChange={t12} />;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text size={Sizes.Medium} prominence={Prominence.Potent} variant={Variants.Label}><Intl k="geo:redirectBanner.note" /></Text>;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13) {
    t15 = <div className="GeoBanner__footer">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t15) {
    t16 = <FeatureBase className="GeoBanner" body={<div className="GeoBanner__content">{t10}{t15}</div>} />;
    $[31] = t10;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
export type GeoBannerContentProps = {
  countryCode: PartnerCountryCode;
  onClose: () => void;
};
export const GeoBannerContent = t0 => {
  const $ = _c(4);
  const {
    countryCode,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      layoutRatio: "1-1",
      theme: "darkBlue",
      fullWidth: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== countryCode || $[2] !== onClose) {
    t2 = <FlexibleSection meta={t1} children1={<InnerGeoBanner countryCode={countryCode} onClose={onClose} />} />;
    $[1] = countryCode;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const GeoBanner = () => {
  const $ = _c(3);
  const {
    close,
    countryCode
  } = useGeoBanner();
  if (!countryCode) {
    return null;
  }
  let t0;
  if ($[0] !== close || $[1] !== countryCode) {
    t0 = <GeoBannerContent countryCode={countryCode} onClose={close} />;
    $[0] = close;
    $[1] = countryCode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
function _temp(e) {
  if (e.target.checked) {
    setCookie(geoCookieName, "true", {
      maxAge: 2592000,
      sameSite: "strict",
      secure: true
    });
  } else {
    deleteCookie(geoCookieName, {
      sameSite: "strict",
      secure: true
    });
  }
}